/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';
import type { PersonType } from './PersonType';
import {
    PersonTypeFromJSON,
    PersonTypeFromJSONTyped,
    PersonTypeToJSON,
} from './PersonType';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
} from './Region';

/**
 * Abridged person structure
 * @export
 * @interface PersonRet
 */
export interface PersonRet {
    /**
     * A flag indicating whether the person is active or not
     * @type {boolean}
     * @memberof PersonRet
     */
    active: boolean;
    /**
     * The ID of the person
     * @type {string}
     * @memberof PersonRet
     */
    person_id: string;
    /**
     * 
     * @type {PersonType}
     * @memberof PersonRet
     */
    person_type: PersonType;
    /**
     * 
     * @type {Region}
     * @memberof PersonRet
     */
    region: Region;
    /**
     * 
     * @type {Array<PersonHandle>}
     * @memberof PersonRet
     */
    handles?: Array<PersonHandle>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonRet
     */
    groups?: Array<string>;
    /**
     * Attributes divided into named buckets. Bucket names are top level keys; attributes are values. Attributes consist of key-value pairs. Attribute names (keys) may be at most 70 bytes long. Attribute values must be JSON-serializable and are limited to 64KiB.
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof PersonRet
     */
    attributes?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Check if a given object implements the PersonRet interface.
 */
export function instanceOfPersonRet(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "person_id" in value;
    isInstance = isInstance && "person_type" in value;
    isInstance = isInstance && "region" in value;

    return isInstance;
}

export function PersonRetFromJSON(json: any): PersonRet {
    return PersonRetFromJSONTyped(json, false);
}

export function PersonRetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonRet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': json['active'],
        'person_id': json['person_id'],
        'person_type': PersonTypeFromJSON(json['person_type']),
        'region': RegionFromJSON(json['region']),
        'handles': !exists(json, 'handles') ? undefined : ((json['handles'] as Array<any>).map(PersonHandleFromJSON)),
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'attributes': !exists(json, 'attributes') ? undefined : json['attributes'],
    };
}

export function PersonRetToJSON(value?: PersonRet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'person_id': value.person_id,
        'person_type': PersonTypeToJSON(value.person_type),
        'region': RegionToJSON(value.region),
        'handles': value.handles === undefined ? undefined : ((value.handles as Array<any>).map(PersonHandleToJSON)),
        'groups': value.groups,
        'attributes': value.attributes,
    };
}

